"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateString = void 0;
const createSchemaValidator_1 = require("../createSchemaValidator");
const assert_1 = require("../../assert");
const messages_1 = require("../../messages");
function validateString(value, schema, reportError, messageParams) {
    const { minLength, maxLength, enum: enumArray, pattern } = schema;
    if (!assert_1.assert.isString(value)) {
        return createSchemaValidator_1.ValidationResult.InvalidType;
    }
    if (enumArray && !assert_1.assert.isIn(value, enumArray)) {
        reportError(messages_1.messages.invalidEnumValueMessage(Object.assign({ value, enum: enumArray }, messageParams)), Object.assign(Object.assign({}, messageParams), { value }));
        return createSchemaValidator_1.ValidationResult.Invalid;
    }
    if ((minLength && assert_1.assert.isBelow(value.length, minLength)) ||
        (maxLength && assert_1.assert.isAbove(value.length, maxLength))) {
        reportError(messages_1.messages.invalidStringLengthMessage(Object.assign({ value, minimum: minLength, maximum: maxLength }, messageParams)), Object.assign(Object.assign({}, messageParams), { value }));
        return createSchemaValidator_1.ValidationResult.Invalid;
    }
    if (pattern && !new RegExp(pattern).test(value)) {
        reportError(messages_1.messages.patternMismatchMessage(Object.assign({ value }, messageParams)), Object.assign(Object.assign({}, messageParams), { value }));
        return createSchemaValidator_1.ValidationResult.Invalid;
    }
    return createSchemaValidator_1.ValidationResult.Valid;
}
exports.validateString = validateString;
//# sourceMappingURL=string.js.map